import styled from "styled-components";
import { Modal } from "antd";

const StyledModal = styled(Modal)`
  &.ant-modal {
    .ant-modal-content {
      padding: 32px;
    }

    .ant-modal-header {
      margin-bottom: 24px;
    }

    .ant-modal-title {
      color: #1e1919;
      font-size: 18px;
      font-weight: 700;
    }

    .ant-modal-body {
      max-height: 550px;
      overflow: auto;
    }

    .ant-form-item {
      margin: unset;
    }

    .ant-form-item .ant-form-item-label > label {
      color: #354a5f;
      cursor: pointer;
    }

    .ant-row {
      gap: 8px;
    }

    .ant-form-horizontal .ant-form-item-control {
      flex: none;
    }

    .ant-modal-footer {
      margin-top: 24px;
    }
  }
`;

export default StyledModal;
